/**
 * Local constants for the RCC Visual Flow Map
 *
 * Mirrors the Appendix-D enums published by RnRRCCFacadeServiceModel
 * (operations/flowMonitoring/processFlowMapOperations.smithy). Shared primitives
 * (ComparisonStatus, MetricName, ProcessPathType) are NOT redeclared here — import
 * them from ../dashboard/constants.
 */

/** Stage of the process flow a node belongs to on the Visual Flow Map. */
export enum ProcessType {
    INBOUND = 'INBOUND',
    FIRST_PASS = 'FIRST_PASS',
    SECOND_PASS = 'SECOND_PASS',
    OUTBOUND = 'OUTBOUND',
    DISPOSITION = 'DISPOSITION',
    SUPPORT = 'SUPPORT',
}

/** Time-granularity toggle for the map's metrics. */
export enum MetricInterval {
    FIFTEEN_MINUTES = 'FIFTEEN_MINUTES',
    ONE_HOUR = 'ONE_HOUR',
    SHIFT = 'SHIFT',
    LAST_SHIFT = 'LAST_SHIFT',
}

/** Trend of a path's buffer, carried on its BUFFER metric. */
export enum BufferState {
    ACCUMULATING = 'ACCUMULATING',
    DEPLETING = 'DEPLETING',
    STABLE = 'STABLE',
}
